import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Badge, Button, Card, Col, Divider, List, Popconfirm, Row } from "antd";
import { FileOutlined, DeleteOutlined } from "@ant-design/icons";
import { CalendarOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { SearchOutlined } from "@ant-design/icons";
// import { saveAs } from "file-saver";
//Utils & Ducks
import * as utils from "../../../../utils";
import * as expDucks from "../../../../redux/aspirante/expDigitalDucks";
// import { download } from "../../../../redux/aspirante/reqAcademicoDuck";
import { getColorCotejo } from "../../../../utils";
import { download } from "../../../../redux/aspirante/reqAcademicoDuck";

/**
 * Componente que muestra los Card de cada documento que se haya capturado por el aspirante.
 * @param {object} item: Información a mostrar
 * @param {number} idConcurso: Id del Concurso para poder realizar el eliminado del archivo
 * @param {number} idConvocatoria: Id de la Convocatoria para poder realizar el eliminado del archivo
 * @return {JSX.Element}
 * @author Uriel Carrión
 */
export const CardArchivo = ({ item, idConcurso, idConvocatoria }) => {
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);
  const { listaBandeja } = useSelector((state) => state.expDigital);
  const { bloquearPorFecha } = useSelector(
    (state) => state.bloqueoEstatus.expediente
  );
  const { catalogoExpediente } = useSelector((state) => state.expDigital);
  const concurso = useSelector(
    (state) => state.bloqueoEstatus.expediente.concurso
  );
  // const {
  //   idConcurso: idConcursoBloqueo,
  //   idConvocatoria: idConvocatoriaBloqueo,
  // } = useSelector((state) => state.bloqueoEstatus.expediente.concurso);

  useEffect(() => {
    if (concurso?.idConcurso && concurso?.idConvocatoria) {
      setDisabled(
        idConcurso === concurso.idConcurso &&
          idConvocatoria === concurso.idConvocatoria
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeEliminar = (id) => {
    const documento = getTipoDocumento(id);
    const { idAspirante, idDocumento, idArchivo, rutaArchivo } = documento;
    const json = {
      idAspirante,
      idDocumento,
      idArchivo,
      rutaArchivo,
      idConcurso,
      idConvocatoria,
    };
    dispatch(expDucks.eliminarExpediente(json));
  };

  /**
   * Busca si el tipo de documento ya fue capturado por el aspirante
   * @param {number} id Tipo del documento
   * @returns Object del tipo de documento
   */
  const getTipoDocumento = (id) =>
    listaBandeja.find(({ idDocumento }) => idDocumento === +id);

  /**
   * función para mostrar el modal de los detalles del documento
   * @param {object} documento
   */
  const openModalDetalle = (documento) => {
    dispatch(expDucks.setModalActiveDetalle(true, documento));
  };

  /**
   * Función que permite mostrar el modal visualizando el documento adjuntado
   * @param {object} documento
   */
  const openPDF = (id) => {
    const documento = getTipoDocumento(id);
    if (documento) {
      const { rutaArchivo } = documento;
      dispatch(expDucks.setLoadingLista(true));
      // Se envía la ruta del archivo
      dispatch(download(rutaArchivo))
        .then(({ data }) => {
          let fileURL = window.URL.createObjectURL(data);
          window.open(fileURL);
          dispatch(expDucks.setLoadingLista(false));
        })
        .catch((error) => {
          utils.openNotification("warning", "Atención", utils.ERROR_ARCHIVO);
          dispatch(expDucks.setLoadingLista(false));
        });
    }
  };

  /**
   * Componente que visualiza el nombre del documento en caso de que ya haya sido capturado
   * @param {number} { id } Id del tipo de documento
   * @return {JSX.Element}
   */
  const ExisteDocumento = ({ id }) => {
    const documento = getTipoDocumento(id);

    return (
      <>
        {documento && documento?.justificacion && (
          <Row justify="end" style={{ marginTop: 10 }}>
            <span
              style={{ textDecoration: "underline", fontWeight: 600 }}
              onClick={() => {
                openModalDetalle(documento);
              }}
            >
              Ver detalle...
            </span>
          </Row>
        )}
        <Row className="card-documento-fecha">
          <Col xxl={16} xl={16} lg={16} md={16} sm={16} xs={24}>
            <div className="card-fecha-hora">
              {documento ? (
                <>
                  <FileOutlined /> {documento.nombreArchivo}
                </>
              ) : (
                <>Pendiente por subir</>
              )}
            </div>
          </Col>

          <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
            {documento && (
              <>
                <CalendarOutlined /> {documento.fecha}{" "}
                <Divider type="vertical" /> <ClockCircleOutlined />{" "}
                {documento.hora}
              </>
            )}
          </Col>
        </Row>
      </>
    );
  };

  const getTextCotejo = (id) =>
    catalogoExpediente.find(({ idEstatus }) => idEstatus === +id);

  /**
   * Componente que muestra el texto si el documento ya fue cotejado.
   * @param {JSX.Element} children: JSX.Element que va a encapsular
   * @param {number} id: El id del documento a cotejar
   * @return {JSX.Element} Componente JSX.Element
   */
  const BadgeComponent = ({ children, id }) => {
    const item = getTipoDocumento(id);
    const estatus = getTextCotejo(item?.cotejo);
    return (
      <>
        {item && estatus ? (
          <Badge.Ribbon
            text={estatus.nombre}
            color={getColorCotejo(estatus.idEstatus)}
          >
            {children}
          </Badge.Ribbon>
        ) : (
          children
        )}
      </>
    );
  };

  return (
    <List.Item>
      <Card hoverable className="card-content">
        <BadgeComponent id={item.idDocumento}>
          <Row style={{ marginTop: -10 }}>
            <Col xxl={1} xl={1} lg={1} md={1} sm={1} xs={24}>
              <Divider type="vertical" className="card-divider" />
            </Col>
            <Col xxl={15} xl={15} lg={15} md={15} sm={15} xs={24}>
              <h1 className="card-documento">{item.nombreDocumento}</h1>
            </Col>
            <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={24}>
              {getTipoDocumento(item.idDocumento) && (
                <Row>
                  <Button
                    id="bntCircle"
                    shape="circle"
                    icon={<SearchOutlined />}
                    style={{ marginTop: 0, marginRight: "5px" }}
                    // onClick={() => downloadDocument(item.idDocumento)}
                    onClick={() => openPDF(item.idDocumento)}
                  />
                  {!bloquearPorFecha && disabled && (
                    <Popconfirm
                      title={utils.INFO_ELIMINAR}
                      onConfirm={() => onChangeEliminar(item.idDocumento)}
                      okText="Aceptar"
                      cancelText="Cancelar"
                    >
                      <Button
                        id="bntCircle"
                        shape="circle"
                        icon={<DeleteOutlined />}
                        style={{ marginTop: 0 }}
                      />
                    </Popconfirm>
                  )}
                </Row>
              )}
            </Col>
          </Row>

          {/* ---------------- Valida si existe el documento --------------------- */}
          <ExisteDocumento id={item.idDocumento} />
        </BadgeComponent>
      </Card>
    </List.Item>
  );
};
